import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=b77ccd90&scoped=true&"
import script from "./picture.vue?vue&type=script&lang=js&"
export * from "./picture.vue?vue&type=script&lang=js&"
import style0 from "./picture.vue?vue&type=style&index=0&id=b77ccd90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77ccd90",
  null
  
)

export default component.exports